<template>
  <div class="pb-100">
    <div class="container">
      <div class="section-title">
        <span class="top-title">GET IN TOUCH</span>
        <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">
          Your Gateway to Excellence: Contact Us and Unlock a World of
          Possibilities
        </h2>
      </div>

      <div class="contact-us-bg-wrap">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <div class="contact-us-info">
              <div class="contact-us-single-item">
                <h3>Office Address</h3>
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="icon">
                      <img title="We connect brands with celebrities and influencers for powerful digital campaigns."
                        src="../../assets/images/loaction.png"
                        alt="location"
                      />
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <p>
                      DigiTalentio IT Solutions, OTIS Circle, Bannerghatta Road,
                      Bangalore-560105
                    </p>
                  </div>
                </div>
              </div>
              <div class="contact-us-single-item">
                <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns." >Phone Number</h3>
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="icon">
                      <img title="We connect brands with celebrities and influencers for powerful digital campaigns." src="../../assets/images/call.png" alt="call" />
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <a title="We connect brands with celebrities and influencers for powerful digital campaigns." href="tel:+919986516463" class="d-block">
                      +91 9986-51-6463
                    </a>
                    <a title="We connect brands with celebrities and influencers for powerful digital campaigns." href="tel:+919113229933" class="d-block">
                      +91 9113-22-9933
                    </a>
                  </div>
                </div>
              </div>
              <div class="contact-us-single-item">
                <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Email Us</h3>
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="icon">
                      <img src="../../assets/images/email-1.png" alt="email" />
                    </div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <a title="MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India." href="mailto:branding@mycelebrity.in" class="d-block">
                      branding@mycelebrity.in
                    </a>
                    <a title="MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India." href="mailto:aradhya@mycelebrity.in" class="d-block">
                      aradhya@mycelebrity.in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-7">
            <div class="contact-us-form">
              <div class="form-group mb-3">
                <label class="label">Your Name</label>
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control rounded-pill"
                  placeholder="Enter your name"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">Your Email</label>
                <input
                  v-model="form.email"
                  type="email"
                  class="form-control rounded-pill"
                  placeholder="Enter your email address"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">Your Phone</label>
                <input
                  v-model="form.phone"
                  type="text"
                  class="form-control rounded-pill"
                  placeholder="Enter your phone number"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">Your Subject</label>
                <input
                  v-model="form.subject"
                  type="text"
                  class="form-control rounded-pill"
                  placeholder="Enter your subject"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">Your Message</label>
                <textarea
                  v-model="form.message"
                  class="form-control"
                  placeholder="Enter your message"
                  cols="30"
                  rows="4"
                ></textarea>
              </div>
              <div class="form-group">
                <button @click.prevent="submitFormToWhatsApp" class="default-btn border-0">
                  SUBMIT NOW
                  <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
                    src="../../assets/images/icon-right-white.png"
                    alt="icon-right-white"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Google Map Section -->
        <div class="row mt-5">
          <div class="col-12">
            <div class="map-embed-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.9581141521126!2d77.62859407575368!3d12.781230819022051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae690036f78659%3A0x971a782c2fbb7b96!2sDigiTalentio%20IT%20Solutions!5e0!3m2!1sen!2sin!4v1749626798808!5m2!1sen!2sin"
                width="100%"
                height="450"
                style="border: 0; border-radius: 20px"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    submitFormToWhatsApp() {
      const { name, email, phone, subject, message } = this.form;

      if (!name || !email || !phone || !subject || !message) {
        alert("Please fill in all fields.");
        return;
      }

      const text = `Hello,%0A*New Contact Form Submission:*%0A--------------------%0A*Name:* ${name}%0A*Email:* ${email}%0A*Phone:* ${phone}%0A*Subject:* ${subject}%0A*Message:* ${message}`;

      const phoneNumber = "919986516463"; // Replace with your WhatsApp number

      const url = `https://wa.me/${phoneNumber}?text=${text}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-us-bg-wrap {
  border-radius: 20px;
  border: 1px solid var(--headingColor);
  background: var(--whiteColor);
}
.contact-us-info {
  background-color: #161519;
  padding: 90px 70px;
  border-radius: 20px;
  margin-right: -30px;
}
.contact-us-single-item {
  border-radius: 20px;
  border: 1px solid #585858;
  padding: 30px;
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
  h3 {
    font-size: 22px;
    color: var(--whiteColor);
    margin-bottom: 25px;
  }
  .icon {
    width: 58px;
    height: 58px;
    line-height: 58px;
    background-color: #4c4c4c;
    text-align: center;
    border-radius: 50px;
  }
  p {
    color: var(--whiteColor);
  }
  a {
    color: var(--whiteColor);
    text-decoration: none;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      color: var(--mainColor);
    }
  }
}
.contact-us-form {
  padding: 60px 90px;
  .form-group {
    label {
      font-size: 16px;
      font-weight: 600;
      font-family: var(--headingFontFamily);
      color: var(--headingColor);
      margin-bottom: 8px;
    }
    .form-control {
      height: 52px;
    }
    textarea {
      &.form-control {
        height: auto;
      }
    }
  }
}

.map-embed-container {
  overflow: hidden;
  border-radius: 20px;
  margin-top: 30px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .contact-us-info {
    padding: 20px;
    margin-right: 0;
  }
  .contact-us-single-item {
    padding: 20px;
    h3 {
      font-size: 18px;
      margin-bottom: 15px;
    }
    p,
    a {
      font-size: 14px;
    }
  }
  .contact-us-form {
    padding: 20px;
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .contact-us-info {
    padding: 50px;
    margin-right: 0;
  }
  .contact-us-single-item {
    h3 {
      font-size: 20px;
      margin-bottom: 15px;
    }
  }
  .contact-us-form {
    padding: 50px;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .contact-us-info {
    padding: 75px 30px;
    margin-right: 0;
  }
  .contact-us-single-item {
    h3 {
      font-size: 20px;
      margin-bottom: 15px;
    }
  }
  .contact-us-form {
    padding: 50px;
  }
}
</style>
